module.exports = __webpack_public_path__ + "img/zhibo.43df7521.png";